export enum CurrencyValue {
	USD = "USD",
	AMD = "AMD",
	GBP = "GBP",
}
